// src/hooks/useGoogleAuth.ts
import { useState } from 'react';
import { signInWithPopup, User } from 'firebase/auth';
import { auth, googleProvider } from '../config/firebase';

interface GoogleLoginResult {
  success: boolean;
  user?: User;
  error?: string;
}

interface GoogleAuthHook {
  signInWithGoogle: () => Promise<GoogleLoginResult>;
  isLoading: boolean;
}

export const useGoogleAuth = (): GoogleAuthHook => {
  const [isLoading, setIsLoading] = useState(false);

  const signInWithGoogle = async (): Promise<GoogleLoginResult> => {
    setIsLoading(true);
    
    try {
      const result = await signInWithPopup(auth, googleProvider);
      const user = result.user;
      
      console.log('Google Sign-in successful:', {
        uid: user.uid,
        displayName: user.displayName,
        email: user.email,
        photoURL: user.photoURL
      });

      return {
        success: true,
        user: user
      };

    } catch (error: any) {
      console.error('Google Sign-in error:', error);
      
      // Handle specific error codes
      let errorMessage = 'Google sign-in failed. Please try again.';
      
      switch (error.code) {
        case 'auth/popup-closed-by-user':
          errorMessage = 'Sign-in was cancelled.';
          break;
        case 'auth/popup-blocked':
          errorMessage = 'Popup was blocked by browser. Please allow popups and try again.';
          break;
        case 'auth/network-request-failed':
          errorMessage = 'Network error. Please check your connection and try again.';
          break;
        case 'auth/too-many-requests':
          errorMessage = 'Too many attempts. Please try again later.';
          break;
        default:
          errorMessage = error.message || errorMessage;
      }

      return {
        success: false,
        error: errorMessage
      };
    } finally {
      setIsLoading(false);
    }
  };

  return {
    signInWithGoogle,
    isLoading
  };
};